module.exports = __webpack_public_path__ + "img/partners-icon12.f2777d3c.jpg";